import React, { useEffect, useState } from "react";
import { userWalletCardRemove, userWalletCardDetailClose, userWalletCardBalanceFetch, userWalletCardPinRequest } from "../../../../actions/creators/user/walletCards";
import { connect } from "react-redux";
import { getSelectedCard, isWalletCardDetailOpen, isWalletCardRemoving } from "../../../../reducers/user/wallet-cards";
import BottomPanel from "../../../BottomPanel";
import TicketCardDetail from "./card-detail/TicketcardCardDetail";
import MoviecardCardDetail from "./card-detail/MoviecardCardDetail";
import CinefanCardDetail from "./card-detail/CinefanCardDetail";
import { GiftCard } from "../../../../types/gift-card";
import UserWalletCard from "../UserWalletCard";
import styled from "styled-components";
import Barcode from "../../../common/Barcode";
import MDSpinner from "react-md-spinner";
import UserWalletCardBalance from "./card-detail/UserWalletCardBalance";
import { CARD_TYPE } from "../../../../types/card-type";
import { breakpoints } from "../../../../utils/styles";

const CardContainer = styled.div`
    body.theme-market & {
        background-color: white;
        color: black;
        padding: 1rem;
        // @todo check this
    }
`;

const BarcodeContainer = styled.div`
    width: 90%;
    margin: 0 auto;

    & svg {
        margin-bottom: -0.5rem;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
        max-width: 21rem;
    }
`;

const RequestPinButton = styled.button`
    background: none;
    border: none;
    color: var(--text-primary);
    cursor: pointer;
    font-size: 1.25rem;
    font-weight: bold;
    margin: 2rem auto 0.5rem;
    outline: none;

    &:focus {
        outline: none;
    }

    & > i {
        margin-left: 0.5rem;
    }
`;

type Props = {
    giftCard: GiftCard;
    isOpen: boolean;
    isRemoving: boolean;
    cardBalanceFetch: (id: number) => void;
    cardPinRequest: (id: number) => void;
    cardRemove: (id: number) => void;
    close: () => void;
};

const UserWalletCardDetail: React.FC<Props> = ({ isOpen, close, giftCard, cardRemove, cardBalanceFetch, cardPinRequest, isRemoving }) => {
    if (!giftCard) return null;

    useEffect(() => {
        if (giftCard && giftCard.id && !('balance' in giftCard)) {
            cardBalanceFetch(giftCard.id);
        }
    }, [giftCard]);

    const components = {
        [CARD_TYPE.MOVIECARD]: {
            title: "Moviecard",
            component: MoviecardCardDetail,
        },
        [CARD_TYPE.CINEFAN]: {
            title: "Cinefan",
            component: CinefanCardDetail,
        },
        [CARD_TYPE.TICKETCARD]: {
            title: "Ticketcard",
            component: TicketCardDetail,
        },
    } as const;

    const selectedComponent = components[giftCard.type];
    const isExpired = giftCard.balance && giftCard.balance.expirationDate && new Date(giftCard.balance.expirationDate) < new Date();

    return (
        <>
            <BottomPanel
                open={isOpen}
                onClose={close}
                title={selectedComponent.title}
            >
                <CardContainer>
                    <UserWalletCard>
                        <img
                            src={giftCard.image}
                            alt="Moviecard"
                        />
                    </UserWalletCard>
                    <BarcodeContainer>
                        <Barcode value={giftCard.cardNumber} copy={false} />
                    </BarcodeContainer>
                </CardContainer>

                {!isExpired && (
                    <>
                        {CARD_TYPE.MOVIECARD === giftCard.type && <PinButton card={giftCard} request={cardPinRequest} />}

                        {!giftCard.balance
                            ? <div className="p-5 text-center"><MDSpinner singleColor="var(--primary)" /></div>
                            : <UserWalletCardBalance balance={giftCard.balance} />
                        }

                        {selectedComponent.component && React.createElement(selectedComponent.component, { giftCard })}
                    </>
                )}

                {isExpired && (
                    <p className="text-primary mt-5">Esta tarjeta está caducada. ¿Deseas eliminarla?</p>
                )}

                <a href="#" className="font-weight-bold text-center mt-4" onClick={e => {
                    e.preventDefault();
                    giftCard.id && cardRemove(giftCard.id);
                }}>
                    Eliminar esta Tarjeta
                </a>
            </BottomPanel>
        </>
    );
};

interface PinButtonProps {
    request: (id: number) => void;
    card: GiftCard;
}

const PinButton: React.FC<PinButtonProps> = ({ request, card }) => {
    const [showPin, setShowPin] = useState(true);
    const onClick = !card.pin ? () => request(card.id) : () => setShowPin(!showPin);

    return (
        <RequestPinButton onClick={onClick}>
            {!card.pin || !showPin
                ? <>Ver PIN <i className="fal fa-eye"></i></>
                : <>PIN: {card.pin} <i className="fal fa-eye-slash"></i></>
            }
        </RequestPinButton>
    );
};

const mapStateToProps = (state: any) => ({
    isOpen: isWalletCardDetailOpen(state),
    isRemoving: isWalletCardRemoving(state),
    giftCard: getSelectedCard(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    close: () => dispatch(userWalletCardDetailClose()),
    cardBalanceFetch: (id: number) => dispatch(userWalletCardBalanceFetch(id)),
    cardPinRequest: (id: number) => dispatch(userWalletCardPinRequest(id)),
    cardRemove: (id: number) => dispatch(userWalletCardRemove(id)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserWalletCardDetail);
